/**
 * Write all the form structures/object in this file. 
 * Or can be imported from local json
 * Remove this file in case you get the dynamic fields data from backend
 */
import { Injectable, Input } from "@angular/core";

import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { FormActionsService } from "./form-actions.service";
import { CustomValidatorService } from "../common/custom-validator.service"
import { CommonService } from '../common/common.service';
import { from } from "rxjs";


@Injectable()
export class FormDefinitionsService {
  /**
   * key in each object will be the form control name
   */
  signUpFormInputsConfig = [
    {
      type: "text",
      placeholder: "Full Name",
      label: "Full Name",
      required: true,
      key: "name",
      value: "",
      controlType: "inputText",
      validators: [Validators.required, CustomValidatorService.validateName]
    }, {
      type: "email",
      placeholder: "Email",
      label: "",
      required: true,
      key: "email",
      value: "",
      controlType: "inputText",
      validators: [Validators.required, CustomValidatorService.validateEmail]
    }, {
      type: "number",
      placeholder: "Phone number",
      label: this.commonService.phoneExtension,
      required: true,
      key: "phone_number",
      value: "",
      controlType: "inputTextWithLable",
      leftLable: true,
      validators: [Validators.required, CustomValidatorService.validateMobile]
    },{
      type: "checkbox",
      placeholder: "",
      label: 'I accept the',
      label1:' Terms & Coditions',
      required: true,
      key: "accept_terms",
      value: "",
      controlType: "checkbox",
      leftLable: true,
      validators: [Validators.required]
    }, {
      type: "button",
      placeholder: "",
      label: "Proceed",
      required: true,
      key: "",
      value: "",
      controlType: "submitButton",
      validators: [],
      callback: "",
    }
  ];
  signupForm = {
    formGroup: null,
    formInputs: this.signUpFormInputsConfig
  };

  vuaCreationInputsConfig = [
    {
      type: "text",
      placeholder: "Set VUA",
      label: this.commonService.vuaExtension,
      required: true,
      key: "vua",
      value: "",
      controlType: "inputTextWithLable",
      rightLable: true,
      validators: [Validators.required]
    }, {
      type: "password",
      placeholder: "Password",
      label: "",
      required: true,
      key: "password",
      value: "",
      controlType: "inputText",
      validators: [Validators.required]
    }, {
      type: "password",
      placeholder: "Set Consent Pin",
      label: "",
      required: true,
      key: "consentPin",
      maxLength: this.commonService.consentPinLength,
      value: "",
      controlType: "inputText",
      validators: [Validators.required, CustomValidatorService.validateConsentPin]
    }, {
      type: "button",
      placeholder: "",
      label: "Register",
      required: true,
      key: "",
      value: "",
      controlType: "submitButton",
      validators: [],
      callback: "",
    }
  ];
  vuaCreationForm = {
    formGroup: null,
    formInputs: this.vuaCreationInputsConfig
  };
  
  loginFormInputsConfig = [
    {
      type: "text",
      placeholder: "Mobile Number",
      label: '',//this.commonService.vuaExtension,
      required: true,
      key: "vua",
      value: "9880680383",
      controlType: 'inputText',//"inputTextWithLable",
      rightLable: true,
      validators: [Validators.required]
    }, {
      type: "password",
      placeholder: "Password",
      label: "",
      required: true,
      key: "password",
      value: "",
      controlType: "inputText",
      validators: [Validators.required]
    }, {
      type: "button",
      placeholder: "",
      label: "Login",
      required: true,
      key: "",
      value: "",
      controlType: "submitButton",
      validators: [],
      callback: "",
    }
  ];
  loginForm = {
    formGroup: null,
    formInputs: this.loginFormInputsConfig
  };

  forgotPwdInputsConfig = [
    {
      type: "text",
      placeholder: "VUA",
      label: this.commonService.vuaExtension,
      required: true,
      key: "vua",
      value: "",
      controlType: "inputTextWithLable",
      rightLable: true,
      validators: [Validators.required]
    }, {
      type: "button",
      placeholder: "",
      label: "Send OTP",
      required: true,
      key: "",
      value: "",
      controlType: "submitButton",
      validators: [],
      callback: "",
    }
  ]
  forgotPwdForm = {
    formGroup: null,
    formInputs: this.forgotPwdInputsConfig
  };

  confirmPwdInputsConfig = [
    {
      type: "text",
      placeholder: "Code",
      label: "",
      required: true,
      key: "confirmationCode",
      value: "",
      controlType: "inputText",
      validators: [Validators.required]
    }, {
      type: "password",
      placeholder: "New Password",
      label: "",
      required: true,
      key: "newPassword",
      value: "",
      controlType: "inputText",
      validators: [Validators.required]
    }, {
      type: "button",
      placeholder: "",
      label: "Confirm",
      required: true,
      key: "",
      value: "",
      controlType: "submitButton",
      validators: [],
      callback: "",
    }
  ]
  confirmPwdForm = {
    formGroup: null,
    formInputs: this.confirmPwdInputsConfig
  };

  profileEditInputsConfig = [
    {
      type: "text",
      placeholder: "Full Name",
      label: "",
      required: true,
      key: "name",
      value: "",
      controlType: "inputText",
      validators: [Validators.required]
    }, {
      type: "text",
      placeholder: "Phone number",
      label: this.commonService.phoneExtension,
      required: true,
      key: "phone_number",
      value: "",
      controlType: "inputTextWithLable",
      leftLable: true,
      validators: [Validators.required]
    }, {
      type: "email",
      placeholder: "Email",
      label: "",
      required: true,
      disabled: true,
      key: "email",
      value: "",
      controlType: "inputText",
      validators: [Validators.required, CustomValidatorService.validateEmail]
    }, {
      type: "text",
      placeholder: "VUA",
      label: this.commonService.vuaExtension,
      required: true,
      disabled: true,
      key: "vua",
      value: "",
      controlType: "inputTextWithLable",
      rightLable: true,
      validators: [Validators.required]
    }, {
      type: "button",
      placeholder: "",
      label: "Save",
      required: true,
      key: "",
      value: "",
      controlType: "submitButton",
      validators: [],
      callback: "",
    }, {
      type: "button",
      placeholder: "",
      label: "Cancel",
      required: true,
      key: "",
      value: "",
      controlType: "cancelButton",
      validators: [],
      callback: "",
    }
  ]
  profileEditForm = {
    formGroup: null,
    formInputs: this.profileEditInputsConfig
  };

  changePasswordInputsConfig = [
    {
      type: "password",
      placeholder: "Password",
      label: "",
      required: true,
      key: "oldpassword",
      value: "",
      controlType: "inputText",
      validators: [Validators.required]
    }, {
      type: "password",
      placeholder: "Confirm Password",
      label: "",
      required: true,
      key: "newpassword",
      value: "",
      controlType: "inputText",
      validators: [Validators.required]
    }, {
      type: "button",
      placeholder: "",
      label: "Change",
      required: true,
      key: "",
      value: "",
      controlType: "submitButton",
      validators: [],
      callback: "",
    }, {
      type: "button",
      placeholder: "",
      label: "Cancel",
      required: true,
      key: "",
      value: "",
      controlType: "cancelButton",
      validators: [],
      callback: "",
    }
  ]
  changePasswordForm = {
    formGroup: null,
    formInputs: this.changePasswordInputsConfig
  };

  changeConsentPinInputsConfig = [
    {
      type: "password",
      placeholder: "Set Consent Pin",
      label: "",
      required: true,
      key: "oldpin",
      maxLength: this.commonService.consentPinLength,
      value: "",
      controlType: "inputText",
      validators: [Validators.required, CustomValidatorService.validateConsentPin]
    }, {
      type: "password",
      placeholder: "Confirm Consent Pin",
      label: "",
      required: true,
      key: "newpin",
      maxLength: this.commonService.consentPinLength,
      value: "",
      controlType: "inputText",
      validators: [Validators.required, CustomValidatorService.validateConsentPin]
    }, {
      type: "button",
      placeholder: "",
      label: "Change",
      required: true,
      key: "",
      value: "",
      controlType: "submitButton",
      validators: [],
      callback: "",
    }, {
      type: "button",
      placeholder: "",
      label: "Cancel",
      required: true,
      key: "",
      value: "",
      controlType: "cancelButton",
      validators: [],
      callback: "",
    } 
  ]
  changeConsentPinForm = {
    formGroup: null,
    formInputs: this.changeConsentPinInputsConfig
  };
  
  constructor(
    private formActionService: FormActionsService,
    private commonService : CommonService
    ) {
    //SignUpForm
    this.signupForm.formGroup = this.formActionService.toReactiveForm(
      this.signUpFormInputsConfig
    );
    this.signupForm.formInputs = this.signUpFormInputsConfig;

    //VuaCreation
    this.vuaCreationForm.formGroup = this.formActionService.toReactiveForm(
      this.vuaCreationInputsConfig
    );
    this.vuaCreationForm.formInputs = this.vuaCreationInputsConfig;

    //LoginForm
    this.loginForm.formGroup = this.formActionService.toReactiveForm(
      this.loginFormInputsConfig
    );
    this.loginForm.formInputs = this.loginFormInputsConfig;

    //Forgot Password
    this.forgotPwdForm.formGroup = this.formActionService.toReactiveForm(
      this.forgotPwdInputsConfig
    );
    this.forgotPwdForm.formInputs = this.forgotPwdInputsConfig;

    //Confirm Password
    this.confirmPwdForm.formGroup = this.formActionService.toReactiveForm(
      this.confirmPwdInputsConfig
    );
    this.confirmPwdForm.formInputs = this.confirmPwdInputsConfig;

    //Profile Edit 
    this.profileEditForm.formGroup = this.formActionService.toReactiveForm(
      this.profileEditInputsConfig
    );
    this.profileEditForm.formInputs = this.profileEditInputsConfig;

    //Change Password
    this.changePasswordForm.formGroup = this.formActionService.toReactiveForm(
      this.changePasswordInputsConfig
    );
    this.changePasswordForm.formInputs = this.changePasswordInputsConfig;

     //Change Consent
     this.changeConsentPinForm.formGroup = this.formActionService.toReactiveForm(
      this.changeConsentPinInputsConfig
    );
    this.changeConsentPinForm.formInputs = this.changeConsentPinInputsConfig;
  }
}
